/* global grecaptcha */

import thumbUpIcon from '@SvgIcon/thumbsup.svg'
import thumbDownIcon from '@SvgIcon/thumbsdown.svg'

import $ from 'jquery'
import Vue from 'vue'
import 'jarallax/dist/jarallax'
import svgIconHtml from '../../shared/svgIconHtml'
import { onRecaptchaV3Available } from '../../shared/recaptcha'

import '../../../scss/app/page.scss'

const FeedbackComponent = Vue.extend({
  // language=HTML
  template: `
    <div class="feedback-form">
      <div v-if="!thanks">
        <div v-if="!formVisible" class="form-group">
          <label>Was this page helpful?</label>
          <button type="button" class="hollow button helpful" @click="markYes">
            ${svgIconHtml(thumbUpIcon)}
            <span class="ib">Yes</span>
          </button>
          <button type="button" class="hollow button unhelpful" @click="markNo">
            ${svgIconHtml(thumbDownIcon)}
            <span class="ib">No</span>
          </button>
        </div>
        <div v-else>
          <p v-if="isHelpful">
            <b>Great!</b> <br>
            Do you have any suggestions?
          </p>
          <p v-else>
            How can we improve it?
          </p>
          <div class="form-group">
            <textarea
              aria-label="How can we improve it?"
              rows="3" cols="30" maxlength="1000"
              v-focus
              v-model="feedback"></textarea>
          </div>
          <div class="form-group">
            <label>If you would like to discuss, please enter your email address:</label>
            <input
              type="email"
              aria-label="Your email address"
              maxlength="255"
              v-model="email" />
          </div>
          <button type="button" class="button" @click="submitFeedback">Submit</button>
        </div>
      </div>
      <div v-else>
        <p>Thanks for your feedback!</p>
      </div>
    </div>
  `,
  props: {
    feedbackUrl: {
      type: String,
      required: true,
    },
    recaptchaKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      feedback: '',
      email: '',
      isHelpful: true,
      formVisible: false,
      thanks: false,
    }
  },
  methods: {
    markYes() {
      this.isHelpful = true
      this.formVisible = true
    },
    markNo() {
      this.isHelpful = false
      this.formVisible = true
    },
    submitFeedback() {
      this.thanks = true

      const makeRequest = (recaptchaToken) => {
        $.ajax({
          type: 'POST',
          url: this.feedbackUrl,
          data: {
            recaptchaToken,
            helpful: this.isHelpful ? 1 : 0,
            feedback: this.feedback,
            email: this.email,
            url: window.location.pathname,
            ua: navigator.userAgent,
          },
        }).fail(() => {
        })
      }

      if (this.recaptchaKey) {
        onRecaptchaV3Available(() => {
          grecaptcha.ready(() => {
            grecaptcha.execute(this.recaptchaKey, { action: 'submit' }).then((token) => {
              makeRequest(token)
            })
          })
        })
      } else {
        makeRequest(null)
      }
    },
  },
})

if (document.querySelector('.feedback-form')) {
  new Vue({
    el: '.feedback-form',
    render(h) {
      return h(FeedbackComponent, {
        props: {
          feedbackUrl: this.$el.attributes['data-feedback'].value,
          recaptchaKey: this.$el.attributes['data-recaptcha-key'].value,
        },
      })
    },
  })
}
